<template>
  <div>
    <div class="body">
      <van-image
        class="topLogo"
        :src="require('../../../../public/image/05/1.png')"
      ></van-image>
      <div class="bodywarp">
        <!-- <van-image
          class="bodywarpImage"
          :src="require('')"
        ></van-image> -->
        <div class="bodyEl">
          <div class="bodyElHeader">
            <van-image
              :src="require('../../../../public/image/05/8.png')"
            ></van-image>
            <van-image
              @click="
                show = true
                getButton('活動說明')
              "
              :src="require('../../../../public/image/05/3.png')"
            ></van-image>
          </div>
          <div class="bodyElTest">
            <van-image
              :src="require('../../../../public/image/05/4.png')"
            ></van-image>
          </div>
          <div class="bodyElList">
            <van-row gutter="20">
              <van-col v-for="item in list" :key="item.image" span="12">
                <div
                  class="listwarp"
                  @click="
                    clickme(item.isSuccess, item.scrollIntoView, item.title)
                  "
                >
                  <div>
                    <van-image
                      class="iconImage"
                      :src="
                        require(`../../../../public/image/05/1/${item.image}`)
                      "
                    ></van-image>
                  </div>
                  <div class="success" v-if="item.isSuccess">
                    <van-image
                      :src="require(`../../../../public/image/05/5.png`)"
                    ></van-image>
                  </div>
                </div>
              </van-col>
            </van-row>
          </div>
          <div class="bodyElButton">
            <a href="javascript:;" @click="submit">
              <van-image
                :src="require('../../../../public/image/05/7.png')"
              ></van-image>
            </a>
          </div>
        </div>
      </div>
    </div>
    <ReadmeDialog
      :titleImage="require('../../../../public/image/12/11/4.png')"
      :backgroundImage="require('../../../../public/image/12/11/1.png')"
      :removeImage="require('../../../../public/image/12/11/3.png')"
      :textImage="require('../../../../public/image/12/11/2.png')"
      :visible.sync="show"
      @changeVisible="show = !show"
    />
    <CheckInDialog
      :backgroundImage="require('../../../../public/image/12/11/1.png')"
      :removeImage="require('../../../../public/image/12/11/3.png')"
      :textImage="require('../../../../public/image/12/9/1.png')"
      :visible.sync="showCheckIn"
      @changeVisible="showCheckIn = !showCheckIn"
    />
    <CheckInDialog
      :backgroundImage="require('../../../../public/image/12/11/1.png')"
      :removeImage="require('../../../../public/image/12/11/3.png')"
      :textImage="require('../../../../public/image/12/8/1.png')"
      :visible.sync="showPhone"
      @changeVisible="showPhone = !showPhone"
    />
    <SubmitDialog
      :imgid="imgid"
      v-if="submitVisible"
      :backgroundImage="require('../../../../public/image/12/11/1.png')"
      :removeImage="require('../../../../public/image/12/11/3.png')"
      :textListImage="require('../../../../public/image/12/7/4.png')"
      :textImage="require('../../../../public/image/12/7/1.png')"
      :textImage1="require('../../../../public/image/12/7/2.png')"
      :titleImage="require('../../../../public/image/12/7/3.png')"
      :visible.sync="submitVisible"
      @changeVisible="submitVisible = !submitVisible"
    />
  </div>
</template>

<script>
import isMobile from '../../../../utils/isMobile.js'
// import { Dialog } from 'vant'
import ReadmeDialog from '../components/readmeDialog/index.vue'
import CheckInDialog from '../components/checkInDialog/index.vue'
import SubmitDialog from '../components/submitDialog/index.vue'
import getData from '../../../../utils/request/request'
import getButton from '../../../../utils/getButton'

import { Toast } from 'vant'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['phone', 'gameStatus'])
  },
  components: {
    ReadmeDialog,
    CheckInDialog,
    SubmitDialog
  },
  data() {
    return {
      show: false,
      //手机预约
      showPhone: false,
      //打卡
      showCheckIn: false,
      //
      submitVisible: false,
      imgid: '',
      isMobile: isMobile(),
      list: [
        {
          type: 'yuyuestatus',
          image: '1.png',
          isSuccess: false,
          scrollIntoView: '#Activity02',
          title: '完成手機預約-去完成按鈕'
        },
        {
          type: 'shopstatus',
          image: '2.png',
          isSuccess: false,
          scrollIntoView: '#Activity02',
          title: '完成商店預約-去完成按鈕'
        },
        {
          type: 'fbazstatus',
          image: '3.png',
          isSuccess: false,
          scrollIntoView: '#Activity02',
          title: '點讚FB-去完成按鈕'
        },
        {
          type: 'fbststatus',
          image: '4.png',
          isSuccess: false,
          scrollIntoView: '#Activity02',
          title: '加入社團-去完成按鈕'
        },
        {
          type: 'zystatus',
          image: '5.png',
          isSuccess: false,
          scrollIntoView: '#Activity03',
          title: '選擇職業-去完成按鈕'
        },
        {
          type: 'slmstatus',
          image: '7.png',
          isSuccess: false,
          scrollIntoView: '#Activity04',
          title: '挑戰史萊姆-去完成按鈕'
        }
      ]
    }
  },
  watch: {
    gameStatus: {
      handler(val) {
        this.list.forEach((item) => {
          if (val[item.type]) {
            this.$set(item, 'isSuccess', true)
          } else {
            this.$set(item, 'isSuccess', false)
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getButton(val) {
      getButton(val)
    },
    clickme(val, item, title) {
      getButton(title)
      if (!val) {
        this.$emit('scrollIntoView', item)
      }
    },
    async submit() {
      // this.showCheckIn = true //打卡全部
      // this.showPhone = true
      // this.submitVisible = true
      getButton('領取獎勵')
      let Api = {
        url: '/api/send_collectgift',
        type: 'post'
      }
      let form = {
        phone: this.phone
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        this.imgid = res.id
        this.submitVisible = true
      } else {
        switch (res.msg) {
          case '未滿足條件':
            this.showCheckIn = true
            break
          case '請先完成手機預約':
            this.$emit('showPhoneHandel')
            break
          default:
            Toast(res.msg)
            break
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .van-row {
  padding: 0rem 2rem;
}
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes heartbeat1 {
  0% {
    transform: translateY(0rem);
  }
  50% {
    transform: translateY(1rem);
  }
  100% {
    transform: translateY(0rem);
  }
}

.body {
  &::before {
    content: '';
    display: table;
  }
  width: 100%;
  background: url(../../../../public/image/10/05.jpg) no-repeat;
  background-size: 100% 100%;
  .topLogo {
    display: block;
    width: 80%;
    margin: 0 auto;
    margin-top: 30px;
  }
}
// .iconImage {
//   width: 88px;
//   height: 105px;
// }
.bodywarp {
  position: relative;
  width: 80%;
  margin: 0 auto;
  background: url(../../../../public/image/05/2.png) no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  .bodywarpImage {
    width: 100%;
    height: 500px;
  }
  .bodyEl {
    // position: absolute;
    padding: 10px 20px 20px 20px;
    box-sizing: border-box;
    top: 0;
    width: 100%;
    height: 100%;
    .bodyElHeader {
      // display: flex;
      // justify-content: space-between;
      // position: relative;
      overflow: hidden;
      line-height: 20px;

      /deep/ .van-image:nth-child(1) {
        height: 25px;
        width: 130px;
        position: absolute;
        top: 10px;
        left: 0px;
      }
      /deep/ .van-image:nth-child(2) {
        height: 10px;
        width: 38px;
        float: right;
        margin-top: 10px;
        margin-bottom: 2px;
      }
    }
    .bodyElTest {
      margin-top: 0.5rem;
    }
    .bodyElList {
      .listwarp {
        position: relative;
        .success {
          position: absolute;
          top: 40%;
          transform: translateY(-50%);
          right: -20%;
          width: 50%;
          z-index: 1000;
          /deep/ .van-image {
          }
        }
        .noSuccess {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 70%;
        }
      }
    }
    .bodyElButton {
      width: 50%;
      margin: 0.5rem auto 0px;
      a {
        display: block;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/Activity05/index.vue